import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const NAV_COLS = [
  {
    title: "Experience",
    links: [
      { label: "How it works", to: "/#how" },
      { label: "The journey", to: "/#journey" },
      { label: "Membership", to: "/membership" },
      { label: "Concierge", to: "/membership#concierge" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
      { label: "Press", to: "/contact#press" },
      { label: "Careers", to: "/contact#careers" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Safety", to: "/safety" },
      { label: "Cookies", to: "/privacy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#05070d] pt-16 pb-10">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Logo size="md" />
            <p className="mt-5 text-white/55 text-sm max-w-xs leading-relaxed">
              Most swipe apps are built for activity. BoraMoyo is built for
              outcomes — structured matching designed for more intentional
              decisions and more meaningful connections.
            </p>
              <div className="mt-5 space-y-3 text-xs text-white/35">
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/25">Contact Info</div>

                <div>
                  <div className="text-[10px] uppercase tracking-[0.18em] text-white/20 mb-1">Phone</div>
                  <a href="tel:+18176011920" className="block hover:text-white/70 transition-colors" aria-label="Call Bora Moyo">+1 (817) 601-1920</a>
                </div>

                <div>
                  <div className="text-[10px] uppercase tracking-[0.18em] text-white/20 mb-1">Emails</div>
                  <div className="space-y-1">
                    <a href="mailto:hello@boramoyo.com" className="block hover:text-white/70 transition-colors" aria-label="Email Bora Moyo">hello@boramoyo.com</a>
                    <a href="mailto:support@boramoyo.com" className="block hover:text-white/70 transition-colors">support@boramoyo.com</a>
                    <a href="mailto:safety@boramoyo.com" className="block hover:text-white/70 transition-colors">safety@boramoyo.com</a>
                    <a href="mailto:privacy@boramoyo.com" className="block hover:text-white/70 transition-colors">privacy@boramoyo.com</a>
                    <a href="mailto:press@boramoyo.com" className="block hover:text-white/70 transition-colors">press@boramoyo.com</a>
                  </div>
                </div>
              </div>
          </div>

          {NAV_COLS.map((col) => (
            <div key={col.title}>
              <div className="text-[11px] tracking-[0.24em] uppercase text-[#D4AF37] mb-4">
                {col.title}
              </div>
              <ul className="space-y-2.5 text-sm text-white/65">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to.startsWith("http") ? (
                      <a
                        href={l.to}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                      >
                        {l.label}
                      </a>
                    ) : (
                      <Link to={l.to} className="hover:text-white transition-colors">
                        {l.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="h-px bg-white/5 mt-12" />

        <div className="mt-8 text-center">
          <p className="text-xs tracking-[0.18em] uppercase text-white/30">
            Structured matching. More intentional decisions. Better relationship results.
          </p>
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <div className="flex flex-wrap items-center gap-4">
            <span>&copy; {new Date().getFullYear()} Bora Moyo. Decide with intention.</span>
            <Link to="/privacy" className="hover:text-white/70 transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-white/70 transition-colors">Terms</Link>
            <Link to="/safety" className="hover:text-white/70 transition-colors">Safety</Link>
          </div>
          <div className="font-mono tracking-wider">v 1.0 · refined build · Site Created By AM Now Developers</div>
        </div>
      </div>
    </footer>
  );
}
